import { computed } from "vue";
import type { IInstallmentPlanComponentObject } from "nlb-buy-go-library";
import { useInformativeCalculationStore } from "../informative-calculation-store";

export function useInstallmentPlanDataObject() {
    const informativeCalculationStore = useInformativeCalculationStore();

    const InstallmentPlanDataObject = computed<IInstallmentPlanComponentObject>({
        get: () => ({
            calculationId: informativeCalculationStore.InfoState.CalculationData.calculationId,
            creditAmount: informativeCalculationStore.InfoState.CalculationData.creditAmount,
            installmentNr: informativeCalculationStore.InfoState.CalculationData.installmentNr,
            lastMonthsIncome: informativeCalculationStore.InfoState.CalculationData.lastMonthsIncome,
            lastMonthsIncome2: informativeCalculationStore.InfoState.CalculationData.lastMonthsIncome2,
            lastMonthsIncome3: informativeCalculationStore.InfoState.CalculationData.lastMonthsIncome3,
            productList: informativeCalculationStore.InfoState.CalculationData.productList,
            specialProductList: informativeCalculationStore.InfoState.CalculationData.specialProductList,
            selectedProduct: informativeCalculationStore.InfoState.CalculationData.selectedProduct,
            selectedProductType: informativeCalculationStore.InfoState.CalculationData.selectedProductType,
            selectedSpecialProduct: informativeCalculationStore.InfoState.CalculationData.selectedSpecialProduct,
            flowType: informativeCalculationStore.InfoState.CalculationData.flowType,
           
            }),
        
        set: (newValues: IInstallmentPlanComponentObject) => {
            informativeCalculationStore.InfoState.CalculationData.calculationId = newValues.calculationId;
            informativeCalculationStore.InfoState.CalculationData.creditAmount = newValues.creditAmount;
            informativeCalculationStore.InfoState.CalculationData.installmentNr = newValues.installmentNr;
            informativeCalculationStore.InfoState.CalculationData.lastMonthsIncome = newValues.lastMonthsIncome;
            informativeCalculationStore.InfoState.CalculationData.lastMonthsIncome2 = newValues.lastMonthsIncome2;
            informativeCalculationStore.InfoState.CalculationData.lastMonthsIncome3 = newValues.lastMonthsIncome3;
            informativeCalculationStore.InfoState.CalculationData.lastMonthsIncome3 = newValues.lastMonthsIncome3;
            informativeCalculationStore.InfoState.CalculationData.lastMonthsIncome3 = newValues.lastMonthsIncome3;
            informativeCalculationStore.InfoState.CalculationData.productList = newValues.productList;
            informativeCalculationStore.InfoState.CalculationData.specialProductList = newValues.specialProductList;
            informativeCalculationStore.InfoState.CalculationData.selectedProduct = newValues.selectedProduct;
            informativeCalculationStore.InfoState.CalculationData.selectedProductType = newValues.selectedProductType;
            informativeCalculationStore.InfoState.CalculationData.selectedSpecialProduct = newValues.selectedSpecialProduct;
            informativeCalculationStore.InfoState.CalculationData.flowType = newValues.flowType;
            
        }
    });

    return { InstallmentPlanDataObject };
}
